module.exports = __webpack_public_path__ + "static/img/10.722c6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/sp/10.png
// module id = 0xmO
// module chunks = 0